/**
 * Common English stop-words that add noise to relevance scoring.
 * Filtered out so they don't dilute match quality.
 */
export const SEARCH_STOP_WORDS = new Set([
  "a", "an", "the", "and", "or", "but", "in", "on", "at", "to", "for",
  "of", "by", "is", "are", "was", "were", "be", "been", "will", "that",
  "this", "with", "from", "it", "its",
]);

/**
 * Normalize a raw search query string into the list of terms used for scoring.
 *
 * Rules (applied in order):
 *  1. Split on whitespace.
 *  2. Keep any 1–4 character token that is entirely ASCII letters (e.g. "AI", "Ai",
 *     "ai", "US", "uk") — short letter-only tokens are almost always meaningful
 *     abbreviations regardless of the capitalisation the user typed.
 *  3. Drop single-character tokens that are not purely ASCII letters; they match too broadly.
 *  4. Lowercase everything.
 *  5. Remove stop-words.
 *
 * Shared by the API server (market-fetch.ts) and the web frontend (markets-page.tsx)
 * so both sides always apply identical tokenisation and stop-word logic.
 */
export function normalizeSearchTerms(query: string): string[] {
  return query
    .split(/\s+/)
    .filter((t) => /^[A-Za-z]{1,4}$/.test(t) || t.length > 1)
    .map((t) => t.toLowerCase())
    .filter((t) => !SEARCH_STOP_WORDS.has(t));
}
